<main class="dentist-application-page" [dir]="isAr ? 'rtl' : 'ltr'">
  <section class="dentist-application-card">
    <header class="page-heading">
      <span>{{ 'atw.dentistApply.badge' | transloco }}</span>
      <h1>{{ 'atw.dentistApply.title' | transloco }}</h1>
      <p>{{ 'atw.dentistApply.subtitle' | transloco }}</p>
    </header>

    <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <div class="application-stepper">
        <ng-container *ngFor="let step of steps; let index = index; let last = last">
          <button
            type="button"
            class="step-pill"
            [class.active]="currentStep === index"
            [class.done]="currentStep > index"
            (click)="index <= currentStep && (currentStep = index)"
          >
            <span>{{ step }}</span>{{ getStepLabel(index) }}
          </button>

          <i class="step-line" *ngIf="!last"></i>
        </ng-container>
      </div>

      <!-- ========================= -->
      <!-- Step 1: Dentist Data -->
      <!-- ========================= -->
      <ng-container *ngIf="currentStep === 0">
        <div class="form-grid">
          <label>
            <span>{{ 'atw.dentistApply.fullName' | transloco }} *</span>
            <input type="text" formControlName="full_name" />
            <small *ngIf="isInvalid('full_name')">
              {{ 'atw.dentistApply.required' | transloco }}
            </small>
          </label>

          <label>
            <span>{{ 'atw.dentistApply.mobile' | transloco }} *</span>
            <input type="tel" formControlName="mobile" />
            <small *ngIf="isInvalid('mobile')">
              {{ 'atw.dentistApply.required' | transloco }}
            </small>
          </label>

          <label>
            <span>{{ 'atw.dentistApply.birthDate' | transloco }}</span>
            <input type="date" formControlName="date_of_birth" />
          </label>

          <label>
            <span>{{ 'atw.dentistApply.gender' | transloco }}</span>
            <select formControlName="gender">
              <option value="">—</option>
              <option value="male">{{ 'atw.dentistApply.male' | transloco }}</option>
              <option value="female">{{ 'atw.dentistApply.female' | transloco }}</option>
            </select>
          </label>

          <label>
            <span>{{ 'atw.dentistApply.email' | transloco }}</span>
            <input type="email" formControlName="email" />
            <small *ngIf="isInvalid('email')">
              {{ isAr ? 'البريد الإلكتروني غير صحيح.' : 'Invalid email address.' }}
            </small>
          </label>

          <label>
            <span>{{ 'atw.dentistApply.whatsapp' | transloco }}</span>
            <input type="tel" formControlName="whatsapp_number" />
          </label>

          <label>
            <span>{{ 'atw.dentistApply.specialty' | transloco }} *</span>
            <select formControlName="specialty">
              <option value="">—</option>
              <option *ngFor="let item of specialties" [value]="item">{{ item }}</option>
            </select>
            <small *ngIf="isInvalid('specialty')">
              {{ 'atw.dentistApply.required' | transloco }}
            </small>
          </label>

          <label *ngIf="form.value.specialty === 'Other'">
            <span>{{ 'atw.dentistApply.otherSpecialty' | transloco }}</span>
            <input type="text" formControlName="specialty_other" />
          </label>

          <label>
            <span>{{ 'atw.dentistApply.qualification' | transloco }} *</span>
            <select formControlName="highest_qualification">
              <option value="">—</option>
              <option *ngFor="let item of qualifications" [value]="item">{{ item }}</option>
            </select>
            <small *ngIf="isInvalid('highest_qualification')">
              {{ 'atw.dentistApply.required' | transloco }}
            </small>
          </label>

          <label>
            <span>{{ isAr ? 'مكان الإقامة' : 'Residence place' }}</span>
            <input type="text" formControlName="residence_place" />
          </label>

          <label>
            <span>{{ isAr ? 'مكان الميلاد' : 'Birth place' }}</span>
            <input type="text" formControlName="birth_place" />
          </label>
        </div>

        <div class="check-grid degree-check-grid">
          <label>
            <input type="checkbox" formControlName="has_phd" />
            {{ isAr ? 'حاصل على دكتوراه' : 'Has PhD' }}
          </label>

          <label>
            <input type="checkbox" formControlName="has_master" />
            {{ isAr ? 'حاصل على ماجستير' : 'Has Master' }}
          </label>
        </div>

        <div class="degree-fields" *ngIf="form.get('has_phd')?.value">
          <h3>{{ isAr ? 'بيانات الدكتوراه' : 'PhD details' }}</h3>

          <div class="form-grid">
            <label>
              <span>{{ isAr ? 'مصدر الدكتوراه' : 'PhD source' }} *</span>
              <input type="text" formControlName="phd_source" />
              <small *ngIf="isInvalid('phd_source')">
                {{ isAr ? 'مصدر الدكتوراه مطلوب.' : 'PhD source is required.' }}
              </small>
            </label>

            <label>
              <span>{{ isAr ? 'سنة الدكتوراه' : 'PhD year' }} *</span>
              <input
                type="number"
                formControlName="phd_year"
                min="1940"
                max="2100"
                [placeholder]="isAr ? 'مثال: 2024' : 'Example: 2024'"
              />
              <small *ngIf="isInvalid('phd_year')">
                {{ isAr ? 'أدخل سنة دكتوراه صحيحة بين 1940 و2100.' : 'Enter a valid PhD year between 1940 and 2100.' }}
              </small>
            </label>
          </div>
        </div>

        <div class="degree-fields" *ngIf="form.get('has_master')?.value">
          <h3>{{ isAr ? 'بيانات الماجستير' : 'Master details' }}</h3>

          <div class="form-grid">
            <label>
              <span>{{ isAr ? 'مصدر الماجستير' : 'Master source' }} *</span>
              <input type="text" formControlName="master_source" />
              <small *ngIf="isInvalid('master_source')">
                {{ isAr ? 'مصدر الماجستير مطلوب.' : 'Master source is required.' }}
              </small>
            </label>

            <label>
              <span>{{ isAr ? 'سنة الماجستير' : 'Master year' }} *</span>
              <input
                type="number"
                formControlName="master_year"
                min="1940"
                max="2100"
                [placeholder]="isAr ? 'مثال: 2020' : 'Example: 2020'"
              />
              <small *ngIf="isInvalid('master_year')">
                {{ isAr ? 'أدخل سنة ماجستير صحيحة بين 1940 و2100.' : 'Enter a valid master year between 1940 and 2100.' }}
              </small>
            </label>
          </div>
        </div>

        <div class="form-grid extra-data-grid">
          <label>
            <span>{{ isAr ? 'الجامعة' : 'University' }}</span>
            <input
              type="text"
              formControlName="university"
              [placeholder]="isAr ? 'اسم الجامعة' : 'University name'"
            />
          </label>

          <label>
            <span>{{ isAr ? 'سنة التخرج' : 'Graduation year' }}</span>
            <input
              type="number"
              formControlName="graduation_year"
              min="1940"
              max="2100"
            />
            <small *ngIf="isInvalid('graduation_year')">
              {{ isAr ? 'أدخل سنة تخرج بين 1940 و2100.' : 'Enter a graduation year between 1940 and 2100.' }}
            </small>
          </label>

          <label>
            <span>{{ isAr ? 'الزمالة' : 'Fellowship' }}</span>
            <input type="text" formControlName="fellowship" />
          </label>

          <label>
            <span>{{ isAr ? 'حالة التصنيف' : 'Classification status' }}</span>
            <input type="text" formControlName="classification_status" />
          </label>

          <label>
            <span>{{ 'atw.dentistApply.scfhsStatus' | transloco }}</span>
            <select formControlName="scfhs_status">
              <option value="">—</option>
              <option value="yes">{{ 'atw.dentistApply.classified' | transloco }}</option>
              <option value="in_progress">{{ 'atw.dentistApply.inProgress' | transloco }}</option>
              <option value="no">{{ 'atw.dentistApply.notRegistered' | transloco }}</option>
            </select>
          </label>

          <label *ngIf="form.value.scfhs_status && form.value.scfhs_status !== 'no'">
            <span>{{ 'atw.dentistApply.classificationLevel' | transloco }}</span>
            <select formControlName="scfhs_classification_level">
              <option value="">—</option>
              <option *ngFor="let level of classificationLevels" [value]="level.value">
                {{ isAr ? level.ar : level.en }}
              </option>
            </select>
          </label>

          <label *ngIf="form.value.scfhs_status && form.value.scfhs_status !== 'no'">
            <span>{{ 'atw.dentistApply.classificationDate' | transloco }}</span>
            <input type="date" formControlName="scfhs_classification_date" />
          </label>

          <label>
            <span>{{ 'atw.dentistApply.experience' | transloco }}</span>
            <select formControlName="years_of_practice">
              <option value="">—</option>
              <option value="less_than_1">&lt; 1</option>
              <option value="1_3">1–3</option>
              <option value="4_7">4–7</option>
              <option value="more_than_7">7+</option>
            </select>
          </label>

          <label>
            <span>{{ 'atw.dentistApply.employment' | transloco }}</span>
            <select formControlName="preferred_employment_type">
              <option value="">—</option>
              <option value="full_time">{{ 'atw.dentistApply.fullTime' | transloco }}</option>
              <option value="part_time">{{ 'atw.dentistApply.partTime' | transloco }}</option>
              <option value="open">{{ 'atw.dentistApply.open' | transloco }}</option>
            </select>
          </label>

          <label *ngIf="isSurgery()">
            <span>{{ 'atw.dentistApply.practiceEnvironment' | transloco }}</span>
            <select formControlName="preferred_practice_environment">
              <option value="">—</option>
              <option value="hospital">{{ 'atw.dentistApply.hospital' | transloco }}</option>
              <option value="dental_clinic">{{ 'atw.dentistApply.clinic' | transloco }}</option>
            </select>
          </label>
        </div>

        <div class="check-grid">
          <label>
            <input type="checkbox" formControlName="ksa_experience" />
            {{ isAr ? 'لديه خبرة في السعودية' : 'Has KSA experience' }}
          </label>

          <label>
            <input type="checkbox" formControlName="transfer_of_sponsorship" />
            {{ isAr ? 'نقل الكفالة' : 'Transfer of sponsorship' }}
          </label>

          <label>
            <input type="checkbox" formControlName="visa" />
            {{ isAr ? 'توجد تأشيرة' : 'Visa available' }}
          </label>

          <label>
            <input type="checkbox" formControlName="has_dataflow" />
            {{ isAr ? 'حاصل على داتا فلو' : 'Has DataFlow' }}
          </label>
        </div>
      </ng-container>

      <!-- ========================= -->
      <!-- Step 2: Documents -->
      <!-- ========================= -->
      <ng-container *ngIf="currentStep === 1">
        <label class="full-width">
          <span>{{ 'atw.dentistApply.portfolio' | transloco }}</span>
          <input type="url" formControlName="portfolio_link" />
        </label>

        <fieldset>
          <legend>{{ 'atw.dentistApply.certificates' | transloco }}</legend>

          <label class="toggle">
            <input type="checkbox" formControlName="has_additional_certificates" />
            {{ 'atw.dentistApply.hasCertificates' | transloco }}
          </label>

          <div class="certificate-grid" *ngIf="form.value.has_additional_certificates">
            <label *ngFor="let item of certificateOptions">
              <input
                type="checkbox"
                [checked]="certificates.includes(item)"
                (change)="toggleCertificate(item, $any($event.target).checked)"
              />
              {{ item }}
            </label>
          </div>
        </fieldset>

        <section class="upload-step upload-step-image">
          <div class="upload-icon">
            <img src="assets/as/16.webp" alt="" />
          </div>

          <strong>{{ 'atw.dentistApply.image' | transloco }}</strong>
          <p>{{ 'atw.doctorApply.imageText' | transloco }}</p>

          <input
            #dentistImageInput
            type="file"
            accept="image/*"
            hidden
            (change)="onImageChange($event)"
          />

          <button
            type="button"
            class="upload-button"
            (click)="dentistImageInput.click()"
            [attr.title]="selectedImage?.name || ('atw.doctorApply.chooseImage' | transloco)"
          >
            <span class="file-name">
              {{ selectedImage ? selectedImage.name : ('atw.doctorApply.chooseImage' | transloco) }}
            </span>
            <span class="upload-arrow">⬆</span>
          </button>
        </section>
      </ng-container>

      <!-- ========================= -->
      <!-- Step 3: CV + Notes -->
      <!-- ========================= -->
      <ng-container *ngIf="currentStep === 2">
        <label class="full-width">
          <span>{{ 'atw.dentistApply.notes' | transloco }}</span>
          <textarea formControlName="additional_notes" rows="4"></textarea>
        </label>

        <section class="cv-option certificates-upload-option">
          <div>
            <strong>{{ isAr ? 'رفع الشهادات و سي في' : 'Upload certificates and CV' }}</strong>
            <p>
              {{
                isAr
                  ? 'يمكنك رفع الشهادات وملف السي في.'
                  : 'You can upload certificates and your CV.'
              }}
            </p>
          </div>

          <input
            #dentistCvInput
            type="file"
            accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            hidden
            (change)="onCvChange($event)"
          />

          <button
            type="button"
            class="secondary-action"
            (click)="dentistCvInput.click()"
            [attr.title]="selectedCv?.name || (isAr ? 'اختيار السي في' : 'Choose CV')"
          >
            <span class="file-name">
              {{ selectedCv ? selectedCv.name : (isAr ? 'اختيار السي في' : 'Choose CV') }}
            </span>
          </button>

          <button
            *ngIf="selectedCv"
            type="button"
            class="text-button"
            (click)="removeCv()"
          >
            {{ isAr ? 'حذف السي في' : 'Remove CV' }}
          </button>

          <input
            #certificatesInput
            type="file"
            accept=".jpg,.jpeg,.png,.webp,.pdf,image/*,application/pdf"
            multiple
            hidden
            (change)="onCertificatesChange($event)"
          />

          <button
            type="button"
            class="secondary-action"
            (click)="certificatesInput.click()"
          >
            {{
              selectedCertificates.length
                ? (isAr ? 'إضافة ملفات أخرى' : 'Add more files')
                : (isAr ? 'اختيار الشهادات' : 'Choose certificates')
            }}
          </button>

          <button
            *ngIf="selectedCertificates.length"
            type="button"
            class="text-button"
            (click)="clearCertificates()"
          >
            {{ isAr ? 'حذف كل الشهادات' : 'Remove all certificates' }}
          </button>

          <small *ngIf="certificateErrorMessage" class="form-message error">
            {{ certificateErrorMessage }}
          </small>

          <div class="selected-files" *ngIf="selectedCertificates.length">
            <p>
              {{
                isAr
                  ? 'الملفات المختارة: ' + selectedCertificates.length + ' / 20'
                  : 'Selected files: ' + selectedCertificates.length + ' / 20'
              }}
            </p>

            <div
              class="selected-file-row"
              *ngFor="let file of selectedCertificates; let i = index; trackBy: trackByFile"
            >
              <span>{{ file.name }}</span>

              <button
                type="button"
                class="text-button"
                (click)="removeCertificate(i)"
              >
                {{ isAr ? 'حذف' : 'Remove' }}
              </button>
            </div>
          </div>
        </section>
      </ng-container>

      <p class="message error" *ngIf="errorMessage">{{ errorMessage }}</p>
      <p class="message success" *ngIf="successMessage">{{ successMessage }}</p>

      <footer>
        <button
          type="button"
          class="secondary-action"
          (click)="currentStep ? previousStep() : back()"
        >
          {{ isAr ? 'رجوع' : 'Back' }}
        </button>

        <button
          *ngIf="currentStep < 2"
          type="button"
          class="primary-action"
          (click)="nextStep()"
        >
          {{ 'atw.doctorApply.next' | transloco }}
        </button>

        <button
          *ngIf="currentStep === 2"
          type="submit"
          class="primary-action"
          [disabled]="isSubmitting"
        >
          {{
            isSubmitting
              ? ('atw.dentistApply.submitting' | transloco)
              : ('atw.dentistApply.submit' | transloco)
          }}
        </button>
      </footer>
    </form>
  </section>
</main>
